import React from "react";
import type { ModeRendererProps } from "./types";

export function VasarelyKangarooMode({ Copy }: ModeRendererProps) {
  return (
    <g>
      <rect width={794} height={1123} fill="#fff6ea" />
      <path d="M220 700 C300 450, 494 450, 574 700 L520 760 L274 760 Z" fill="#b86b2b" />
      <g className="mode-copy" transform="translate(48,840)" fill="#221"><text x={0} y={0} fontSize={18}>{Copy?.title}</text></g>
    </g>
  );
}

export default VasarelyKangarooMode;
